const defaultProductsImg = {
  Food: require('@/assets/defaultProductsImg/Food.jpg'),
  Drink: require('@/assets/defaultProductsImg/Drink.jpg'),
  Alcohol: require('@/assets/defaultProductsImg/Alcohol.jpg'),
}
/**
 * Get the default product image of the corresponding type
 * @param {String} imgUrl Image url， Format: https: //api-dev.mondomenu.com/img/product/Food.jpg
 * @return {String} Default picture of corresponding type
 */
/**
 * 获取对应类型的默认商品图片
 * @param {String} imgUrl 图片 url， 格式： https: //api-dev.mondomenu.com/img/product/Food.jpg
 * @return {String} 对应类型的默认图片
 */
export function _getDefaultProductsImg(imgUrl) {
  const urlList = imgUrl.split('/')
  const url = urlList[urlList.length - 1]
  const type = url.split('.')[0]
  return defaultProductsImg[type]
}
